import { Component } from 'react';
import { RelatedLink } from '../../../types/site-urls';
import styles from './related-links.component.module.scss';
import { groupBy } from '../../../utils/lodash-min';
import { StringUtils } from '../../../utils/string-utils';


interface RelatedLinksComponentProps {
    relatedLinks: RelatedLink[];
}
export class RelatedLinksComponent extends Component<RelatedLinksComponentProps> {
    relatedLinks: { title: string; links: RelatedLink[]; }[];

    constructor(props: RelatedLinksComponentProps) {
        super(props);
        const groups = groupBy(this.props.relatedLinks, (v) => v.converterType.type);
        this.relatedLinks = Object.keys(groups).map(k => {
            return {
                title: StringUtils.capitalizeFirstLetter(k),
                links: groups[k]
            }
        }).sort().reverse()

    }

    componentDidCatch(err) {
        console.log(err);
    }

    render() {
        return <div className="card section text-left" >
            <div className='row'>
                {
                    this.relatedLinks.map((v) => {
                        return <div className={(v.links.length > 16 ? 'col-12' : 'col-12 col-md-6') + ' mb-3'} key={v.title}>
                            <h5 className={styles['section-title']}>Related {v.title} tools</h5>
                            <div className={v.links.length > 16 ? styles['pills-grid'] : styles['pills']}>
                                {
                                    v.links.filter(link => link.converterType)
                                        .map((link, index) => <a key={index} href={link.url} title={link.converterType.title} className={styles['pill']}>
                                            {link.converterType.title}</a>)
                                }
                            </div>
                        </div>
                    })
                }
            </div>
        </div >
    }
}